import React from "react";

export default function Footer() {
  return (
    <footer className="w-full border-t border-white/10 bg-cocoa-900/60 py-10">
      <div className="container-page flex flex-col items-center gap-3 text-center">
        <div className="flex items-center gap-2 text-sm font-semibold text-amber-200">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-amber-400/20">
            <svg
              className="h-3.5 w-3.5"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.25}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
              />
            </svg>
          </span>
          Real-Time Interview Platform
        </div>
        <p className="text-sm text-amber-100/50">
          &copy; {new Date().getFullYear()} Interviewly. All rights reserved.
        </p>
        <p className="text-xs text-amber-100/35">
          Built with React &amp; Tailwind CSS
        </p>
      </div>
    </footer>
  );
}
